import ReactGA from 'react-ga4';
import { getConsent } from './cookieConsent';

const IS_LOCALHOST =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

function isGAEnabled(): boolean {
  // Require cookie consent (shared across app.offerflow.pro + offerflow.pro).
  if (getConsent() !== 'granted') return false;
  if (!IS_LOCALHOST) return true;
  try {
    return localStorage.getItem('ga_localhost') === 'true';
  } catch {
    return false;
  }
}

let gaInitialized = false;

// Safe to call multiple times. Does nothing until the user has granted consent;
// the cookie banner re-invokes it on "Accept" to start analytics immediately.
export function initGA(): void {
  const measurementId = process.env.REACT_APP_GA_ID;
  if (!measurementId) return;

  if (!isGAEnabled()) {
    (window as any)[`ga-disable-${measurementId}`] = true;
    return;
  }

  if (gaInitialized) return;
  ReactGA.initialize(measurementId, {
    gaOptions: {
      debug_mode: IS_LOCALHOST,
      cookie_domain: 'app.offerflow.pro',
      linker: { domains: ['offerflow.pro'], accept_incoming: true } as any,
    },
  });
  gaInitialized = true;
  (window as any)[`ga-disable-${measurementId}`] = false;
}

export function trackPageView(path: string): void {
  if (!isGAEnabled()) return;
  ReactGA.send({ hitType: 'pageview', page: path });
}

export function track(event: string, params?: Record<string, unknown>): void {
  if (!isGAEnabled()) {
    console.debug('[GA] suppressed (localhost):', event, params ?? '');
    return;
  }
  ReactGA.event(event, params);
}

export function setUser(userId: string, planTier?: string): void {
  if (!isGAEnabled()) return;
  ReactGA.set({ userId, ...(planTier ? { plan_tier: planTier } : {}) });
}
